import { PwrCnt } from '../model/pwrcnt.model';
import { AnalysisService } from '../services/analysis.service';
import { PricingService } from '../services/pricing.service';
import { RecommendationService } from '../services/recommendation.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-reccomendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.css']
})
export class RecommendationsComponent implements OnInit {


  constructor(
    private recommendationService: RecommendationService,
    private analysisService: AnalysisService) {
  };

  ngOnInit() {
  }

  getIsHK(): boolean {
    return isHK;
  }

  showRecommendations(): boolean {
    return (this.analysisService.getRoofArea() > 0);
  }


  // ----------

  getExactPanelsPower() {
    return this.recommendationService.exactPanelsPower;
  }

  getMatchingPanels() {
    return this.recommendationService.panelForCurrReq[0];
  }

  getMatchingPanelsPower() {
    return this.recommendationService.getMatchingPanelsPower();
  }

  getMatchingPanelsPeakPower() {
    return this.recommendationService.getPeakPower4CurrReq();
  }

  getMatchingPanelsArea() {
    return this.recommendationService.matchingPanelsArea;
  }

  getMatchingPanelsCnt() {
    return this.recommendationService.matchinPanelsCnt;
  }

  getPowerCoverage(): number {
    return this.recommendationService.powerCoverage;
  }


  getMaxPanelsPower() {
    return this.recommendationService.maxPanelsPower / 1000;
  }

  getMaxPanelsArea() {
    return this.recommendationService.maxPanelsArea;
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/recommendations/recommendations.component.ts